<template>
  <div class="box">
    <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
      <div class="title">Anmelden</div>
      <div class="field">
        <label for="usernameInput" class="label">Nutzername</label>
        <div class="control">
          <Field
            id="usernameInput"
            name="usernameInput"
            class="input"
            type="text"
            v-model="credentials.username"
            autocomplete="username"
          />
          <div class="has-text-danger">{{ errors.usernameInput }}</div>
        </div>
      </div>
      <div class="field">
        <label for="passwordInput" class="label">Passwort</label>
        <div class="control">
          <Field
            id="passwordInput"
            name="passwordInput"
            class="input"
            type="password"
            v-model="credentials.password"
            autocomplete="current-password"
          />
          <div class="has-text-danger">{{ errors.passwordInput }}</div>
        </div>
      </div>
      <div v-if="generalError" class="has-text-danger">
        {{ generalError }}
      </div>
      <div class="field">
        <div class="control">
          <input
            class="button is-primary"
            :class="{ 'is-loading': loading }"
            type="submit"
            value="Anmelden"
          />
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Field, Form } from "vee-validate";
import { object, string } from "yup";

export default {
  components: {
    Form,
    Field,
  },
  setup() {
    const schema = object().shape({
      usernameInput: string().required("Nutzername ist ein Pflichtfeld"),
      passwordInput: string().required("Passwort ist ein Pflichtfeld"),
    });
    return {
      schema,
    };
  },
  data() {
    return {
      generalError: "",
      credentials: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters(["loading"]),
  },
  methods: {
    ...mapActions(["login"]),
    onSubmit() {
      this.generalError = "";
      this.login(this.credentials).catch(() => {
        this.generalError =
          "Sie konnten nicht angemeldet werden. Bitte überprüfen Sie die Eingaben!";
      });
    },
  },
};
</script>
